import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';

// TYPES
import { Types, ExcluirUsuario } from './types';

export const INITIAL_STATE: ExcluirUsuario = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ExcluirUsuario {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_USUARIO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_USUARIO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_USUARIO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_USUARIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
